import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/components/Home.vue'
import MotPresident from '@/components/MotPresident.vue'
import Status from '@/components/Status.vue'
import Adhesion from '@/components/Adhesion.vue'
import Contact from '@/components/Contact.vue'
import SignIn from '@/components/SignIn.vue'
import Articles from '@/components/Articles.vue'
import AddEvent from '@/components/AddEvent.vue'
import AddFollower from '@/components/AddFollower.vue'
import AddNewsletter from '@/components/AddNewsletter.vue'
import WhiteBook from '@/components/WhiteBook.vue'
import AddUser from '@/components/AddUser.vue'
import AddUsersBulk from '@/components/AddUsersBulk.vue'
import Organigramme from '@/components/Organigramme.vue'
import Dashboard from '@/components/Dashboard.vue'
import AddTir from '@/components/AddTir.vue'
import MapTirs from '@/components/MapTirs.vue'
import EnqueteTirs from '@/components/EnqueteTirs.vue'

const routes = [
  { path: '/', component: Home, name: 'Home' },
  { path: '/mot-president', component: MotPresident, name: 'MotPresident' },
  { path: '/status', component: Status, name: 'Status' },
  { path: '/adhesion', component: Adhesion, name: 'Adhesion' },
  { path: '/contact', component: Contact, name: 'Contact' },
  { path: '/login', component: SignIn, name: 'SignIn' },
  { path: '/presse', component: Articles, name: 'Presse', props: { article_type: 'Press' } },
  { path: '/news', component: Articles, name: 'News', props: { article_type: 'News' } },
  { path: '/evenements', component: Articles, name: 'Meetings', props: { article_type: 'Meeting' } },
  { path: '/publications', component: Articles, name: 'Publications', props: { article_type: 'Publication' } },
  { path: '/add-event', component: AddEvent, name: 'AddEvent' },
  { path: '/add-follower', component: AddFollower, name: 'AddFollower' },
  { path: '/newsletter', component: AddNewsletter, name: 'AddNewsletter' },
  { path: '/livre-blanc', component: WhiteBook, name: 'WhiteBook' },
  { path: '/add-user', component: AddUser, name: 'AddUser' },
  { path: '/add-users-bulk', component: AddUsersBulk, name: 'AddUsersBulk' },
  { path: '/organigramme', component: Organigramme, name: 'Organigramme' },
  { path: '/admin', redirect: { path: '/login', query: { nextUrl: '/dashboard' } } },
  { path: '/dashboard', component: Dashboard, name: 'Dashboard' },
  { path: '/membres', name: 'Members', redirect: { path: '/login', query: { nextUrl: '/dashboard-membres' } } },
  { path: '/dashboard-membres', component: Articles, name: 'DashboardMembres', props: { article_type: 'Members' } },
  {
    path: '/mail-selidaire',
    name: 'mail-selidaire',
    beforeEnter () { location.href = 'mailto:a.selidaire@orange.fr'; return false }
  },
  {
    path: '/bulletin-adhesion',
    name: 'bulletin-adhesion',
    beforeEnter () { location.href = '/bulletinadhinternet2026.pdf'; return false }
  },
  { path: '/recenser-tir', component: AddTir, name: 'AddTir' },
  { path: '/carte-tirs', component: MapTirs, name: 'MapTirs' },
  { path: '/enquete-tirs', component: EnqueteTirs, name: 'EnqueteTirs' },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
